<template>
  <span v-if="extendable">
    <p v-if="!isExtended" class="m-4 text-justify" style="white-space: initial">
      <span :inner-html.prop="text | truncate(config.attributes.truncate)">{{
        text
      }}</span>
      <br />
      <a
        class="breadcrumb d-inline text-info"
        href="javascript:;"
        @click="isExtended = true"
      >
        {{ $t("read_more") }}
      </a>
    </p>
    <div v-else class="m-4 text-justify" style="white-space: initial">
      <span v-html="text">{{ text }}</span>
      <br />
      <a
        class="breadcrumb d-inline text-info"
        href="javascript:;"
        @click="isExtended = false"
      >
        {{ $t("less") }}
      </a>
    </div>
  </span>
  <span v-else> {{ text | truncate(190) }}</span>
</template>

<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";

export default {
  name: "text-component",
  mixins: [componentMixin],
  data() {
    return {
      isExtended: false,
    };
  },
  computed: {
    text() {
      return this.tx(this.config.attributes.text || "");
    },
    // on différencie le texte classique ( sans attribut truncate dans le xml) du texte  avec option de collapse
    extendable() {
      return this.attributes.truncate;
    },
  },
};
</script>
